function rewriteLegacyOnboardingPath(path) {
  if (typeof path !== "string") return null;
  if (path === "/onboarding") return "/business/onboarding";
  if (path.startsWith("/onboarding/")) {
    return `/business/onboarding/${path.slice("/onboarding/".length)}`;
  }
  return path;
}

const NEXT_INTERNAL_QUERY_PARAMS = new Set([
  "_rsc",
  "__flight__",
  "__nextDataReq",
]);

// App Router transport parameters are never meaningful destinations. Keeping
// one in a post-auth URL can turn a later full navigation into a Flight fetch.
export function stripNextInternalQueryParams(input) {
  if (typeof input !== "string") return null;
  const trimmed = input.trim();
  if (!trimmed || !trimmed.startsWith("/") || trimmed.startsWith("//")) {
    return null;
  }

  try {
    const url = new URL(trimmed, "https://yourbarrio.invalid");
    NEXT_INTERNAL_QUERY_PARAMS.forEach((key) => url.searchParams.delete(key));
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function normalizeNextPath(input) {
  if (typeof input !== "string") return null;
  const trimmed = input.trim();
  if (!trimmed) return null;

  let candidate = trimmed;
  const lower = trimmed.toLowerCase();
  if (lower.startsWith("http://") || lower.startsWith("https://")) {
    try {
      const parsed = new URL(trimmed);
      candidate = `${parsed.pathname || ""}${parsed.search || ""}`;
    } catch {
      return null;
    }
  }

  if (!candidate.startsWith("/")) return null;
  if (candidate.startsWith("//")) return null;

  const sanitizedCandidate = stripNextInternalQueryParams(candidate);
  if (!sanitizedCandidate) return null;

  const parsed = new URL(sanitizedCandidate, "https://yourbarrio.invalid");
  const rewrittenPathname = rewriteLegacyOnboardingPath(parsed.pathname);
  if (!rewrittenPathname) return null;
  return `${rewrittenPathname}${parsed.search}${parsed.hash}`;
}
